import React from "react";
import {Routes, Route} from 'react-router-dom';
import Login from "../page/Login";
import DocumentList from "../page/DocumentList";
import DataMapping from "../page/DataMapping";
import Dashboard from "../components/Dashboard";
import DashboardLayout from "../components/DashboardLayout";
import { NotFound } from "../components/NotFound";
import ProtectedRoute from "../components/ProtectedRoute";

export const CommonRoutes  = () =>{

return (
     <Routes>
        <Route  path="/" element={<Login/>}/>
         {/* Protected Routes */}
        {/* <Route element={<ProtectedRoute />}> */}
        <Route path="/" element={<ProtectedRoute><DashboardLayout/></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard/>}/>
        <Route path="/document-list" element={<DocumentList/>}/>
        <Route path="/data-mapping" element={<DataMapping/>}/>
        </Route>
        <Route path="*" element={<NotFound />} />
     </Routes>


);

}